<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">概况(按周期)</template>
    <div slot="form">
      <el-date-picker
        v-model="query.time"
        type="monthrange"
        :editable="false"
        unlink-panels
        style="width: 200px"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="getbasicdatastat">查询</el-button>
    </div>
    <summary-list
      :list="list1"
      :span="8" />
    <summary-list
      :list="list2"
      :span="8" />
    <el-divider></el-divider>
    <v-chart
      class="chart"
      :options="line" />
  </layout-card-wrap>
</template>

<script>
import SummaryList from './summary.vue'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import moment from 'moment'
export default {
  name: 'OverviewTimeData',
  components: { SummaryList, 'v-chart': ECharts },
  data() {
    const start = +moment().subtract(6, 'month')
    const end = +moment()
    return {
      loading: true,
      query: {
        time: [start, end]
      },
      list1: [
        {
          label: '入驻企业(家)',
          value: '0'
        },
        {
          label: '产品种类(种)',
          value: '0'
        },
        {
          label: '需求受理(条)',
          value: '0'
        }
      ],
      list2: [
        {
          label: '快检企业(家)',
          value: '0'
        },
        {
          label: '供应链企业(家)',
          value: '0'
        },
        {
          label: '培训人次(人)',
          value: '0'
        }
      ],
      line: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['入驻企业', '产品种类', '需求受理'],
          bottom: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '入驻企业',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '产品种类',
            type: 'line',
            smooth: true,
            data: []
          },
          {
            name: '需求受理',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      }
    }
  },
  mounted() {
    this.getbasicdatastat()
  },
  methods: {
    getbasicdatastat() {
      this.loading = true
      const [start, end] = this.query.time
      this.$store.dispatch('account/getbasicdatastat', {
        payload: {
          beginMonth: moment(start).format('YYYYMM'),
          endMonth: moment(end).format('YYYYMM')
        },
        success: (res) => {
          this.loading = false
          const data = res.data
          this.$set(this, 'list1', [
            {
              label: '入驻企业(家)',
              value: data.vendorCount
            },
            {
              label: '产品种类(种)',
              value: data.productCount
            },
            {
              label: '需求受理(条)',
              value: data.workOrderCount
            }
          ])
          this.$set(this, 'list2', [
            {
              label: '快检企业(家)',
              value: data.inspectionVendorCount
            },
            {
              label: '供应链企业(家)',
              value: data.scmVendorCount
            },
            {
              label: '培训人次(人)',
              value: data.trainingCount
            }
          ])
          const statInfos = data.statInfos
          const xAxis = []
          const series1 = []
          const series2 = []
          const series3 = []
          statInfos.forEach(i => {
            xAxis.push(i.month)
            series1.push(i.vendorCount)
            series2.push(i.productCount)
            series3.push(i.workOrderCount)
          })
          this.line.xAxis.data = xAxis
          this.line.series[0].data = series1
          this.line.series[1].data = series2
          this.line.series[2].data = series3
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.chart {
    width 100%
    height: 300px;
}
</style>
